import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VariantType } from 'app/models/variantTypes.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VariantTypesService {

  typedocumentos: Observable<VariantType[] | any>;
  
  constructor(private http: HttpClient) { }

  getVariantTypes(): Observable<VariantType | any> {
    return this.typedocumentos = this.http.get(environment.apiUrl + 'variant-type');
  }

  getVariantId(id: number): Observable<VariantType | any> {
    return this.http.get(environment.apiUrl + 'variant-type/' + id);
  }

  saveVariantType(variantType: VariantType): Observable<VariantType | any> {
    return this.http.post(environment.apiUrl + 'variant-type', variantType);
  }

  updateVariantType(id:number ,variantType: VariantType): Observable<VariantType | any> {
    return this.http.patch(environment.apiUrl + `variant-type/${id}`, variantType);
  }

  deleteVariantType(id: number): Observable<VariantType | any> {
    return this.http.delete(environment.apiUrl + 'variant-type/' + id);
  }
}
